export const DEPOSIT_OPTIONS = [
  { label: '3,000', value: 3000 },
  { label: '5,000', value: 5000 },
  { label: '10,000', value: 10000 },
  { label: '25,000', value: 25000 },
  { label: '50,000', value: 50000 },
  { label: '100,000', value: 100000 },
  { label: '500,000', value: 500000 },
  { label: '1,000,000', value: 1000000 },
  { label: '5,000,000', value: 5000000 }
];
